module.exports = __webpack_public_path__ + "static/img/4.65e46700.png";